import { MetricUId } from "../../Metrics/constants"
import getChartConfigTemplate from "../Templates/PieChart/utils"
import { mergeProps } from "../../../generic/Utils/mergeProps";

const metricColorMap = {
  [MetricUId.UPCOMING_MEETINGS_COUNT]: "#8E4EC6",
  [MetricUId.OVERDUE_MEETINGS_COUNT]: "#F76B15",
  [MetricUId.COMPLETED_MEETINGS_COUNT]: "#0969DA",
  [MetricUId.CANCELED_MEETINGS_COUNT]: "#E54D2E",
}

export const chartOnlyMetrics = [MetricUId.UPCOMING_MEETINGS_COUNT, MetricUId.OVERDUE_MEETINGS_COUNT, MetricUId.COMPLETED_MEETINGS_COUNT, MetricUId.CANCELED_MEETINGS_COUNT, MetricUId.TOTAL_MEETINGS_COUNT]

const getChartConfig = function(props = {}) {
  const mergedProps = mergeProps(props, {
    seriesMetricsUids: [MetricUId.UPCOMING_MEETINGS_COUNT, MetricUId.OVERDUE_MEETINGS_COUNT, MetricUId.COMPLETED_MEETINGS_COUNT, MetricUId.CANCELED_MEETINGS_COUNT],
    subTitleMetricUid: MetricUId.TOTAL_MEETINGS_COUNT,
    exportFileName: props.name,
    metricColorMap: metricColorMap
  });

  return getChartConfigTemplate(mergedProps);
};

export default getChartConfig;
